import React from 'react'

export default function NewsDrawer({
  isOpen,
  onToggle,
  activeCategory,
  onCategoryChange,
  newsList,
  config,
  lang
}) {
  const isEn = lang === 'en'
  const newsUrl = isEn ? './news?lang=en' : './news'

  const formatDate = val => (val ? String(val).split(' ')[0] : '')

  return (
    <section className={`home-news-drawer ${isOpen ? 'open' : ''}`} data-lang={lang}>
      <div className="news-drawer-body">
        <nav className="news-tab-menus">
          {['latest', 'news', 'notice', 'event'].map(cat => (
            <button
              type="button"
              key={cat}
              className={activeCategory === cat ? 'active' : ''}
              onClick={() => onCategoryChange(cat)}
            >
              {config.categoryNames[cat]}
            </button>
          ))}
          <a href={newsUrl} target="_blank" rel="noopener noreferrer" className="btn-more">
            {isEn ? 'More >>' : '更多 >>'}
          </a>
        </nav>

        <ul className="news-items-list">
          {newsList.map(item => (
            <li key={item.id}>
              <a
                href={`./detail?id=${item.id}${isEn ? '&lang=en' : ''}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <span className="item-cat">[{item.template_name}]</span>
                <span className="item-title flex-1">{item.title}</span>
                <span className="item-date">{formatDate(item.publish_at)}</span>
              </a>
            </li>
          ))}
          {newsList.length === 0 ? (
            <li className="no-news-item">
              {isEn ? 'No news yet' : '暂无新闻'}
            </li>
          ) : null}
        </ul>

        <button
          type="button"
          className="news-close"
          onClick={onToggle}
          aria-label="关闭新闻抽屉"
        />
      </div>
      <button
        type="button"
        className="news-drawer-bar"
        onClick={onToggle}
        aria-label="展开新闻抽屉"
      />
    </section>
  )
}
